import { Injectable } from '@angular/core';
import { parametersEnum } from '../../enums/parameters.enum';

@Injectable({
  providedIn: 'root',
})
export class CryptDataService {
  key: '60abe20843dfb86becad82c4';
  u8array = new Uint8Array(16);

  async descrypterParameters(data) {
    const parameters = Object.keys(parametersEnum);
    data = JSON.stringify(data);
    for (const key in parameters) {
      data = data.replaceAll(parameters[key], parametersEnum[parameters[key]]);
    }
    const arrayString = data.split(/[": ,{}]+/);
    for (const key in arrayString) {
      if (arrayString[key].includes('cdJS')) {
        const prueba = await this.desencrypdata(arrayString[key].substring(4));
        data = data.replaceAll(arrayString[key], prueba);
      }
    }
    console.log('🚀 ~ file: crypt-data.service.ts:31 ~ CryptDataService ~ descrypterParameters ~ data:', data);
    return JSON.parse(data);
  }

  async encryptdata(data: string): Promise<string> {
    const encoder = new TextEncoder();
    const encoderData = encoder.encode(data);
    let cryptoKey = await window.crypto.subtle.importKey('raw', this.u8array, 'AES-GCM', false, ['encrypt']);
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    let encryptData = await window.crypto.subtle.encrypt({ name: 'AES-GCM', iv }, cryptoKey, encoderData);

    return btoa(String.fromCharCode(...iv)) + '.' + btoa(String.fromCharCode(...new Uint8Array(encryptData)));
  }

  async desencrypdata(encrptedData: string): Promise<string> {
    const decoder = new TextDecoder();
    const [ivB64, dataB64] = encrptedData.split('.');
    const iv = new Uint8Array(Array.from(atob(ivB64), c => c.charCodeAt(0)));
    const data = new Uint8Array(Array.from(atob(dataB64), c => c.charCodeAt(0)));
    const cryptoKey = await window.crypto.subtle.importKey('raw', this.u8array, 'AES-GCM', false, ['decrypt']);

    const decryptData = await window.crypto.subtle.decrypt({ name: 'AES-GCM', iv }, cryptoKey, data);
    return decoder.decode(decryptData);
  }

  async generateKey() {
    let encoder;
    encoder.encodeInto(
      this.key,
      this.u8array.subarray(0),
    );
  }
}
